export default {
  groups: [{
      styleClasses: 'col-sm-6 row',
      fields: [{
          type: 'input',
          inputType: 'text',
          label: 'Name',
          model: 'name',
          maxlength: 50,
          required: true,
          placeholder: "Name",
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'ctldate',
          label: 'Date',
          model: 'date',
          required: true,
          placeholder: "Event Date",
          format: "YYYY-MM-DD HH:mm:ss",
          options: {
            nolabel: true
          },
          validator: ['date'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'input',
          inputType: 'url',
          label: 'Link',
          model: 'link',
          required: true,
          placeholder: "Link",
          validator: ['url'],
          styleClasses: 'col-sm-12'
        },
        {
          type: 'select',
          label: 'Entity Type',
          model: 'entity_type',
          required: true,
          values: [],
          styleClasses: 'col-sm-6'
        },
        {
          type: 'select',
          label: 'Entity',
          model: 'entity_id',
          required: true,
          values: [],
          styleClasses: 'col-sm-6'
        },
        {
          type: "textArea",
          label: "Details",
          model: "brief",
          hint: "Max 500 characters",
          max: 500,
          placeholder: "Brief",
          rows: 4,
          validator: ['string'],
          styleClasses: 'col-sm-12'
        },

      ]
    },
    {
      styleClasses: 'col-sm-6 row',
      fields: [{
          type: "cropper",
          model: 'image',
          package: 'croppie',
          label: 'Photo',
          required: true,
          options: {
            aspect: 1,
            width: 400,
            height: 225,
            resizable: false,
          },
          styleClasses: 'col-sm-12'
        },
        {
          type: "select",
          label: "Status",
          model: "status",
          values: [
            "active",
            "inactive"
          ],
          styleClasses: 'col-sm-6'

        }
      ]
    }
  ]
}